module.exports = __webpack_public_path__ + "static/media/dialog_button.404fb6ab.png";